import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useTankTransition = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()
  const useTankTransitionOverviewQuery = (filter) =>
    useQuery({
      queryKey: ['tankTransitionOverview', filter],
      queryFn: ({ queryKey }) =>
        api.post('tank_transition/overview', {
          filter: { ...queryKey[1], store_number: queryKey[1]?.store_number?.toString() },
        }),
      refetchOnWindowFocus: false,
    })

  const removeTransitionMutation = (props: { afterSuccess?: Function } = {}) =>
    useMutation({
      mutationFn: (ids: string[]) => api.post('tank_transition/delete', { transition_ids: ids }),
      // When mutate is called:
      onMutate: async (ids) => {
        // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries({
          queryKey: ['tankTransitionOverview'],
        })

        // Snapshot the previous value
        const previousQueries = queryClient.getQueriesData({
          queryKey: ['tankTransitionOverview'],
        })

        // Optimistically update to the new value
        queryClient.setQueriesData({ queryKey: ['tankTransitionOverview'] }, (oldData) => {
          return {
            ...oldData,
            rows: oldData.rows.map((tank) =>
              ids.includes(tank.tank_transition?.key)
                ? { ...tank, has_transition: false, tank_transition: undefined }
                : tank
            ),
          }
        })

        // Return a context with the previous and new todo
        return { previousQueries, ids }
      },
      onSuccess: () => {
        props?.afterSuccess()
      },
      onError: (_err, _newSite, context) => {
        queryClient.setQueriesData({ queryKey: ['tankTransitionOverview'] }, context.previousQueries)
      },
    })

  return { useTankTransitionOverviewQuery, removeTransitionMutation }
}
